import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'


class FormattedHTMLMessage extends PureComponent {

  static propTypes = {
    children: PropTypes.any,
    tag: PropTypes.string,
    en: PropTypes.string.isRequired,
    es: PropTypes.string,
    values: PropTypes.object,
    name: PropTypes.string, // deprecated - used for debugging missed messages
  }

  static contextTypes = {
    intlData: PropTypes.object,
  }

  render() {
    const { intlData: { intl, locale } } = this.context
    const { children, tag = 'span', tagId, en, es, values, name, defaultMessage, dataTestId, ...rest } = this.props

    const message = intl.formatHTMLMessage({ en, es }, values, locale)

    const node = React.createElement(tag, {
      ...rest,
      id: tagId,
      dangerouslySetInnerHTML: { __html: message },
      'data-testid': dataTestId,
    })

    if (typeof children === 'function') {
      return children(node)
    }

    return node
  }
}


export default FormattedHTMLMessage
